import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-cta to-rose-400 text-white py-2 px-4 text-center shadow-md" data-id="element-279">
      <div className="font-bold text-sm md:text-base" data-id="element-280">
        ⚡🔥 ¡OFERTA DE LANZAMIENTO SOLO POR HOY: $6.36 USD! 🔥⚡
      </div>
      <div className="text-xs md:text-sm font-medium mt-0.5" data-id="element-281">
        El precio vuelve a $47.00 en: ⏰ {formatTime(timeLeft.hours)}:
        {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
      </div>
    </div>;
}